import '../filter_view.js.coffee';# Added by Script 
Monitoring.Views.SocialContents ||= {}
Monitoring.Views.SocialContents.Filters ||= {}

class Monitoring.Views.SocialContents.Filters.LocationFilterView extends Monitoring.Views.SocialContents.Filters.FilterView
  name: 'location'
  facetName: 'location'

  getAppliedValues: () ->
    return @searchQuery.get('locations')

  addFilter: (value) ->
    @searchQuery.addLocation(value)

